import React from "react";
import "../Css/MobileNavigation.css";
import SocialMedia from "../SocialMedia";
import { ReactComponent as MenuIcon } from "../Images/menu-outline.svg";
import { ReactComponent as CloseIcon } from "../Images/close-outline.svg";
import { motion } from "framer-motion";
import { useState, useRef, useEffect } from "react";
export default function MobileNavigation() {
  const [navigationVisablity, setNavigationVisablity] = useState("hide");
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3,
      },
    },
  };
  const item = {
    hidden: { opacity: 0 },
    show: { opacity: 1 },
  };

  const backDrop = useRef();
  useEffect(() => {
    backDrop.current.style.display =
      navigationVisablity === "hide" ? "none" : "block";
  });

  return (
    <motion.div className="MobileNavigation-container">
      <MenuIcon
        className="menu-icon"
        onClick={() => {
          setNavigationVisablity("show");
        }}
        whileTap={{
          scale: 0.9,
        }}
      />
      <motion.div
        className="back-drop"
        ref={backDrop}
        initial={{
          opacity: 0,
        }}
        animate={{
          when: "beforeChildren",
          opacity: navigationVisablity === "hide" ? 0 : 1,
        }}
        onClick={() => setNavigationVisablity("hide")}
      >
        <motion.div
          className="navigation-wrapper"
          initial={{
            x: "100vw",
          }}
          animate={{
            x: navigationVisablity === "hide" ? "100vh" : 0,
          }}
          transition={{
            type: "twean",
            when: "beforeChildren",
            staggerChildren: 0.2,
          }}
        >
          <CloseIcon
            className="close-icon"
            onClick={() => setNavigationVisablity("hide")}
            whileTap={{
              scale: 0.9,
            }}
          />
          <motion.nav variants={container} animate="show" initial="hidden">
            <motion.a
              href="#about"
              onClick={() => setNavigationVisablity("hide")}
            >
              عني
            </motion.a>
            <motion.a
              href="#journey"
              onClick={() => setNavigationVisablity("hide")}
            >
              رحلتي
            </motion.a>
            <motion.a
              href="#recordings"
              onClick={() => setNavigationVisablity("hide")}
            >
              تسجيبلاتي
            </motion.a>
            <motion.a href="#" onClick={() => setNavigationVisablity("hide")}>
              تواصل معي
            </motion.a>
          </motion.nav>

          <SocialMedia container={container} item={item} />
        </motion.div>
      </motion.div>
    </motion.div>
  );
}
